























import Vue, { PropType } from 'vue';
import { CandidateJobBuilder } from '~/utils/candidate';

// Components
import InfoBox from '~/components/profile/components/InfoBox.vue';

export default Vue.extend({
    name: 'SummaryForm',
    components: { InfoBox },
    props: {
        builder: {
            type: Object as PropType<CandidateJobBuilder>,
            required: true,
        },
    },
    data() {
        return {
            summary: this.builder.getCandidateField('summary'),
        };
    },
    mounted() {
        this.$watch('summary', this.builder.watchCandidate('summary'));
    },
});
